@if (content) {
<href [link]="content.cta_url"
      [hrefClass]="'fill'">
    <div class="fill z-2 flex"
         [ngClass]="('flex-' + content.vertical_align)">
        @if (content.image || image()) {
        <div class="w-12 fill overflow-hidden">
            <img [dfImage]="content.image || image()"
                 [ratio]="ratio()"
                 [priority]="priority()"
                 [decoding]="priority() ? 'auto' : 'async'"
                 fill>
        </div>
        }
        @if (content.video_id && content.variant === 'video') {
        <local-vimeo-player class="fill"
                            [video-id]="content.video_id"
                            [autoplay-in-viewport]="true"
                            [background]="true" />
        }
        <!-- content -->
        @if (content.title || content.cta_text) {
        <div class="w-12 pos-relative z-3 p-t-6 p-t-4-m p-t-4-s p-b-6 p-b-4-m p-b-4-s p-l p-l-5-m p-l-5-s p-r p-r-5-m p-r-5-s"
             [ngClass]="content.horizontal_align || 'center'">
            <p [sizeClass]="'!S:hero, S:h1'"
               [style.color]="content.color || '#000'"
               *iCms="'title' of content"></p>
            <!-- button -->
            @if (content.cta_text) {
            <div class="m-t">
                <action [ngClass]="content.cta_style">
                    <span *iCms="'cta_text' of content"></span>
                </action>
            </div>
            }
        </div>
        }
    </div>
</href>
}
